const MessageStatusConst ={
  0:'Terjadwal',
  1:'Sent',
  2:'Delivered',
  3:'Read'
}
export default MessageStatusConst